import React, { Component } from 'react';
import { connect } from 'react-redux';
import localeLookup from '../../../config/locale';

import FormModal from '../FormModal';

import ModalBody from '../ModalBody';
import ModalFooter from '../ModalFooter';
import FormWrapper from '../../formElements/FormWrapper';
import TextField from '../../formElements/TextField';
import Button from '../../Button';

import { rotateUserProvisioningToken } from '../../../services/systemSettingsService';

const mapStateToProps = (state) => ({
  serverErrorMessage: state.userSettings.changePasswordError,
});

class ManageUserProvisioningTokenModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userProvisioningToken: '*',
    };
  }

  rotateProvisioningToken = async () => {
    try {
      const response = await rotateUserProvisioningToken();

      if (response && response.data) {
        this.setState({ userProvisioningToken: response.data.token });
      }
    } catch (error) {
      console.error('Error rotating provisioning token:', error);
      throw error;
    }
  };

  render() {
    const { onClose, title, subtitle, setting } = this.props;
    const { userProvisioningToken } = this.state;
    console.log('setting', setting);
    return (
      <FormModal onClose={onClose} title={title} subtitle={subtitle}>
        <ModalBody center>
          <FormWrapper className="create-person-form" onSubmit={this.onSubmit}>
            {({}) => (
              <>
                <TextField
                  autoComplete="nope"
                  name="userProvisioningUrl"
                  id="userProvisioningUrl"
                  label={localeLookup('translations.User Provisioning URL')}
                  type="text"
                  disabled={true}
                  value={setting.additionalData.TenantUrl}
                />
                <TextField
                  autoComplete="nope"
                  name="userProvisioningToken"
                  id="userProvisioningToken"
                  label={localeLookup('translations.User Provisioning Token')}
                  type="text"
                  disabled={true}
                  value={userProvisioningToken}
                />
                <Button
                  onClick={this.rotateProvisioningToken}
                  className="champ-link-form__button"
                  kind="darkui"
                  fullWidth
                >
                  {localeLookup('translations.Rotate Provisioning Token')}
                </Button>
              </>
            )}
          </FormWrapper>
        </ModalBody>
      </FormModal>
    );
  }
}

export default connect(mapStateToProps)(ManageUserProvisioningTokenModal);
